module.exports = "<div class=\"tagline\" ng-hide=\"$root.isMember\" ng-bind-html=\"main.siteConst.tagline\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/site_core/src/components/tagline/tagline.html
// module id = 180
// module chunks = 0